<template>
  <v-container fluid>
    <v-col cols="12">
      <v-form class="ma-6 pa-0">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dates"
                  label="Дата создания счета"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                range
                locale="ru-RU"
                :first-day-of-week="1"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Отмена
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dates)">
                  Сохранить
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="contragentSelect"
              :items="contragentLists"
              item-text="TITLE"
              item-value="ID"
              label="Контрагент"
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-btn
          text
          color="success"
          class="mr-4"
          @click="getReport"
          :disabled="loading"
        >
          Сформировать
        </v-btn>
        <v-btn
          text
          :disabled="loading"
          color="gray"
          class="mr-4"
          @click="exportPayInvoice"
        >
          Выгрузить Платежный документ
        </v-btn>
      </v-form>
    </v-col>
    <v-col>
      <template>
        <v-data-table
          :headers="headers"
          :items="invoiceIDS"
          :items-per-page="5"
          class="elevation-1"
        >
          <template v-slot:item.delete="{ item }">
            <v-btn @click="deleteItem(item.id)" text>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-col>
  </v-container>
</template>

<script>
import axios from "axios";
//import fileWrite from "file-saver";

export default {
  name: "payinvoice",
  data() {
    return {
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Дата оплаты",
          align: "start",
          sortable: true,
          value: "payDate",
        },
        {
          text: "Дата создания",
          align: "start",
          sortable: true,
          value: "dateCreate",
        },
        {
          text: "Контрагент",
          align: "start",
          sortable: false,
          value: "recipientTitle",
        },
        {
          text: "Сумма платежа",
          align: "start",
          sortable: true,
          value: "sumPay",
        },
        {
          text: "НДС",
          align: "start",
          sortable: false,
          value: "sumTax",
        },
        {
          text: "Основание",
          align: "start",
          sortable: false,
          value: "commentInvoice",
        },
        {
          text: "Статус",
          align: "start",
          sortable: true,
          value: "status",
        },
        {
          text: "Действие",
          align: "start",
          sortable: false,
          value: "delete",
        },
      ],
      menu: false,
      dates: [],
      invoiceIDS: [],
      isPayInvoice: true,
      loading: false,
      normalDate: [],
      contragentSelect: "",
      contragentLists: [],
      statusInfo: { 1457: "Создан", 1459: "Оплачен" },
      url: "https://citystroi.bitrix24.ru/rest/73/gjdt5g3y10jxw3r9/",
    };
  },
  methods: {
    async deleteItem(item) {
      try {
        console.log({ item });
        const index = this.invoiceIDS.findIndex((e) => e.id === item);
        this.invoiceIDS.splice(index, 1);
      } catch (e) {
        console.log(e);
      }
    },
    async getReport() {
      this.loading = true;
      this.invoiceIDS = [];
      this.normalDate = [];

      const propertyValue = (elem) => (elem ? Object.values(elem)[0] : "");

      await this.normalizeDate();
      const params = {
        IBLOCK_TYPE_ID: "bitrix_processes",
        IBLOCK_ID: "63",
        FILTER: {
          ">=DATE_CREATE": this.normalDate[0],
          "<=DATE_CREATE": this.normalDate[1],
          PROPERTY_1199: this.contragentSelect,
        },
      };
      const method = "lists.element.get";
      let i = 1;
      let next = 0;
      while (i > 0) {
        params.start = next;
        //if (this.contragentSelect) params['FILTER']['PROPERTY_1199'] = this.contragentSelect
        const reportData = await axios.post(this.url + method, params);
        next = reportData.data.next;
        console.log({ reportData });
        for (const elem of reportData.data.result) {
          let requisite = [];
          let companyTitle = "";
          if (elem["PROPERTY_1199"]) {
            console.log(elem["PROPERTY_1199"]);
            const companyData = await axios.post(this.url + "crm.company.get", {
              id: propertyValue(elem["PROPERTY_1199"]),
            });
            console.log({ companyData });
            const requisiteData = await axios.post(
              this.url + "crm.requisite.list",
              {
                filter: {
                  ENTITY_TYPE_ID: 4,
                  ENTITY_ID: propertyValue(elem["PROPERTY_1199"]),
                  PRESET_ID: 1,
                },
              }
            );
            console.log({ requisiteData });
            if (requisiteData.data.result.length == 0) {
              const requisiteDataIP = await axios.post(
                this.url + "crm.requisite.list",
                {
                  filter: {
                    ENTITY_TYPE_ID: 4,
                    ENTITY_ID: propertyValue(elem["PROPERTY_1199"]),
                    PRESET_ID: 3,
                  },
                }
              );
              console.log({ requisiteDataIP });
              if (requisiteDataIP.data.result.length > 0) {
                requisite = requisiteDataIP.data.result;
                companyTitle = `ИП ${requisite[0].RQ_NAME}`;
              }
            } else {
              requisite = requisiteData.data.result;
              companyTitle = requisite[0].RQ_COMPANY_FULL_NAME;
            }
            console.log({ requisite });
            const item = {
              id: elem["ID"],
              number: elem["ID"],
              payDate: propertyValue(elem["PROPERTY_459"]),
              dateCreate: elem["DATE_CREATE"],
              contragentID: propertyValue(elem["PROPERTY_1199"]),
              sumPay: propertyValue(elem["PROPERTY_1201"]),
              sumTax: propertyValue(elem["PROPERTY_1203"]),
              commentInvoice: propertyValue(elem["PROPERTY_1205"]),
              idInvoice: propertyValue(elem["PROPERTY_1207"]),
              payDoc: "",
              status: this.statusInfo[propertyValue(elem["PROPERTY_1211"])],
              recipientTitle: companyTitle
                ? companyTitle
                : elem["PROPERTY_1199"]
                ? this.contragentLists.filter(
                    (e) => e.ID == propertyValue(elem["PROPERTY_1199"])
                  )[0].TITLE
                : "",
              recipientINN: requisite.length > 0 ? requisite[0].RQ_INN : "",
              recipientInvoice: companyData.data.result.UF_CRM_1672229960
                ? companyData.data.result.UF_CRM_1672229960
                : "",
              recipientBank: companyData.data.result.UF_CRM_1672229942
                ? companyData.data.result.UF_CRM_1672229942
                : "",
              recipientBankAddress: companyData.data.result.UF_CRM_1707390631
                ? companyData.data.result.UF_CRM_1707390631
                : "",
              recipientBik: companyData.data.result.UF_CRM_1672229952
                ? companyData.data.result.UF_CRM_1672229952
                : "",
              recipientCorInvoice: companyData.data.result.UF_CRM_1672229970
                ? companyData.data.result.UF_CRM_1672229970
                : "",
            };
            this.invoiceIDS.push(item);
          }
        }
        if (!next) {
          i = 0;
        }
      }
      this.loading = false;
    },
    async exportPayInvoice() {
      try {
        this.loading = true;
        const date = new Date();
        let textToWrite = "1CClientBankExchange\n";
        textToWrite += "ВерсияФормата=1.03\n";
        textToWrite += "Кодировка=Windows\n";
        textToWrite += "Отправитель=Бухгалтерия предприятия, редакция 3.0\n";
        textToWrite += "Получатель=\n";
        textToWrite += `ДатаСоздания=${date.toLocaleDateString("ru-RU")}\n`;
        textToWrite += `ВремяСоздания=${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}\n`;
        textToWrite += `ДатаНачала=${date.toLocaleDateString("ru-RU")}\n`;
        textToWrite += `ДатаКонца=${date.toLocaleDateString("ru-RU")}\n`;
        textToWrite += `РасчСчет=40702810902190002079\n`;
        textToWrite += "Документ=Платежное поручение\n";

        const payer =
          "ПлательщикСчет=40702810902190002079\n" +
          'Плательщик=ИНН 7725828411 ООО "СИТИ-СТРОЙ"\n' +
          'ПлательщикИНН=7725828411"\n' +
          'Плательщик1=ООО "СИТИ-СТРОЙ"\n' +
          "ПлательщикРасчСчет=40702810902190002079\n" +
          'ПлательщикБанк1=АО "АЛЬФА-БАНК"\n' +
          "ПлательщикБанк2=г. Москва\n" +
          "ПлательщикБИК=044525593\n" +
          "ПлательщикКорсчет=30101810200000000593\n";

        for (const index in this.invoiceIDS) {
          const documentData =
            "СекцияДокумент=Платежное поручение\n" +
            `Номер=${this.invoiceIDS[index].id}\n` +
            `Дата=${this.invoiceIDS[index].dateCreate.split(" ")[0]}\n` +
            `Сумма=${this.invoiceIDS[index].sumPay}\n`;

          const recipient =
            `ПолучательСчет=${this.invoiceIDS[index].recipientInvoice}\n` +
            `Получатель=ИНН ${this.invoiceIDS[index].recipientINN} ${this.invoiceIDS[index].recipientTitle}\n` +
            `ПолучательИНН=${this.invoiceIDS[index].recipientINN}\n` +
            `Получатель1=${this.invoiceIDS[index].recipientTitle}\n` +
            `ПолучательРасчСчет=${this.invoiceIDS[index].recipientInvoice}\n` +
            `ПолучательБанк1=${this.invoiceIDS[index].recipientBank}\n` +
            `ПолучательБанк2=${this.invoiceIDS[index].recipientBankAddress}\n` +
            `ПолучательБИК=${this.invoiceIDS[index].recipientBik}\n` +
            `ПолучательКорсчет=${this.invoiceIDS[index].recipientCorInvoice}\n` +
            `ВидОплаты=01\n` +
            `Очередность=5\n` +
            `НазначениеПлатежа=${this.invoiceIDS[index].commentInvoice} Сумма ${this.invoiceIDS[index].sumPay} В т.ч. НДС  (20%) ${this.invoiceIDS[index].sumTax}\n` +
            `НазначениеПлатежа1=${this.invoiceIDS[index].commentInvoice}\n` +
            `НазначениеПлатежа2=Сумма ${this.invoiceIDS[index].sumPay}\n` +
            `НазначениеПлатежа3=В т.ч. НДС  (20%) ${this.invoiceIDS[index].sumTax}\n` +
            `КонецДокумента\n`;
          textToWrite += documentData;
          textToWrite += payer;
          textToWrite += recipient;
          if (index == this.invoiceIDS.length - 1) {
            textToWrite += "КонецФайла\n";
          }
        }
        const encodeCP1251 = function(string) {
          function encodeChar(c) {
            var isKyr = function(str) {
              return /[а-я]/i.test(str);
            };
            var cp1251 = 
              "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬*®Ї°±Ііґµ¶·\
ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя";
            var p = isKyr(c) ? cp1251.indexOf(c) + 128 : c.charCodeAt(0);
            var h = p.toString(16);
            if (h == "a") {
              h = "0A";
            }
            return "%" + h;
          }
          var res = "";
          for (var i = 0; i < string.length; i++) {
            res += encodeChar(string.charAt(i)); //ну или string[i]
          }
          return res;
        };

        var a = document.createElement("a");
        a.setAttribute(
          "href",
          "data:text/plain;charset=CP1251," + encodeCP1251(textToWrite)
        );
        a.setAttribute("download", "newInvoice.txt");
        a.click();

        /* var textFileAsBlob = new Blob([textToWrite], {
          encoding: "windows-1251",
          type: "text/plain; charset=cp1251",
        });
        
        fileWrite(textFileAsBlob, "invoice.txt");*/
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    async normalizeDate() {
      try {
        const firstDate = this.dates[0].split("-");
        const twoDate = this.dates[1].split("-");
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(twoDateFormated);
      } catch (e) {
        console.log(e);
      }
    },
    async getContragents() {
      try {
        this.contragentLists = [];
        const params = {
          order: { TITLE: "ASC" },
          filter: {},
          select: ["ID", "TITLE"],
        };
        const method = "crm.company.list";
        let i = 1;
        let next = 0;
        while (i > 0) {
          params.start = next;
          const contragentData = await axios.post(this.url + method, params);
          next = contragentData.data.next;
          for (const elem of contragentData.data.result) {
            this.contragentLists.push(elem);
          }
          if (!next) {
            i = 0;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.getContragents();
    this.loading = false;
  },
};
</script>

<style scoped></style>
